import React from "react";

import {cn} from "@isudio/utils";

const RowContainer: React.FC<React.PropsWithChildren<{
  containerRef?: React.RefObject<HTMLDivElement>
  className?: string
}>> = ({
  containerRef,
  className,
  children
}) => (
  <div
    ref={containerRef}
    className={cn("flex w-full ml-auto mr-auto", className)}
  >
    {children}
  </div>
);

RowContainer.displayName = "RowContainer";
export {RowContainer};